<template>
	<div id="paike">
		<!--<div style="display: none">作者：{{$store.state.userName}}</div>-->
		<div class="fflex fflexV fflexbet" >
			<div>

				<span style="margin-left: 9px;margin-right: 9px">开始时间</span>
				<!--<el-date-picker v-model="stime" size="mini" value-format="yyyy-MM-dd" style="width: 130px" type="date"-->
				 <!--placeholder="选择日期" :picker-options="pickerOptions0"  @change="stfn2">-->
				<el-date-picker v-model="stime" size="mini" value-format="yyyy-MM-dd" style="width: 130px" type="date" placeholder="选择日期"   @change="stfn2">
				</el-date-picker>
				<span style="margin-left: 9px;margin-right: 9px">结束时间</span>

				<el-date-picker value-format="yyyy-MM-dd" v-model="etime" size="mini" @change="stfn2" style="width: 130px"
				 type="date" placeholder="选择日期" >
				</el-date-picker>
			</div>
			<div>
				<el-button size="mini" round @click="ylfbfn">月龄分布</el-button>
				<el-button size="mini" round @click="fanhui">返回</el-button>
			</div>

		</div>


		<div style="width: 100%;overflow-x: scroll">
			<table class="table table-bordered" style="box-shadow: none;margin-top: 10px;width: auto;margin-bottom: 10px;table-layout: fixed">
				<thead>
					<tr>

						<th style="width: 140px!important;background: #fff;padding:0  10px 0 0;"><select name="" v-model="week" class="xiala"
							 @change="zhoucha" style="background:#8CBB77;color: #fff;width: 128px ">
								<option value="1">星期一</option>
								<option value="2">星期二</option>
								<option value="3">星期三</option>
								<option value="4">星期四</option>
								<option value="5">星期五</option>
								<option value="6">星期六</option>
								<option value="7">星期日</option>
							</select>
						</th>
						<th style="width: 160px" v-for="k in class_room_names">{{k.content}}</th>
						<!--<th style="width: 160px">综合教室</th>-->
						<!--<th style="width: 160px">综合教室</th>-->
						<!--<th style="width: 160px">综合教室</th>-->
						<!--<th style="width: 160px">综合教室</th>-->
						<!--<th style="width: 160px">综合教室</th>-->
					</tr>
				</thead>
				<tbody id="tbody">
					<tr v-for="(it,iidex) in infos" class="fuzhi" :key="iidex">
						<td style="padding:5px  10px 5px 0;" v-for="(kks,index) in it" v-if="index==0">
							<div class="fflex fflexC boxshadow" style="background:#f1f1f1;flex-wrap: wrap;border-radius: 5px;padding: 5px "
							 @click="startT(kks)">
								<div class="fflex fflexV" style="margin-bottom: 7px;padding-top: 10px">
									<span>上课时间：</span>
								</div>
								<TimePicker class="sjcj" format="HH:mm" style="width: 100px" type="timerange" @on-change="startTimeChange"
								 :disabled-hours="[0,1,2,3,4,5,6,7,23]" hide-disabled-options :steps="[1, 5, 1]" :value="kks" placement="bottom-start"
								 placeholder="选择上课时间">
								</TimePicker>
							</div>
						</td>
						<td style="padding:5px  10px 5px 0;" v-for="(kk,index) in it" v-if="index>0" @click="pkid(kk.pk_id,kk.kc_id,kk.user_id)">
							<div class="fflex fflexC boxshadow" style="background:#fff;flex-wrap: wrap;border-radius: 5px;padding: 5px;width: 160px ">
								<!--<input type="text" v-model="kk.pk_id" v-if="kk.pk_id">-->
								<div class="fflex fflexV" style="margin-bottom: 5px">
									<span>课程/班级：</span>
									<select name="" v-model="kk.kc_id" class="xiala" @change="xiugai(kk.kc_id,kk.user_id,kk.xiaoke,kk.s_time,kk.x_time)"
									 style="width: 70px;padding: 0">
										<option value="">请选择</option>
										<option :value="ke.kc_id" v-for="ke in need_classes[index-1].classes">{{ke.kc_name}}</option>
									</select>
								</div>
								<div class="fflex fflexV" style="margin-bottom: 5px">
									<span>老师名称：</span> <select name="" v-model="kk.user_id" class="xiala" @change="xiugai(kk.kc_id,kk.user_id,kk.xiaoke,kk.s_time,kk.x_time)"
									 style="width: 70px;padding: 0">
										<option value="">请选择</option>
										<option :value="te.user_id" v-for="te in teachers">{{te.username}}</option>
									</select>
								</div>
							</div>
						</td>
					</tr>

				</tbody>
			</table>
		</div>

		<div @click="zengjia" class="fflex fflexC fflexV boxshadow" style="width: 128px;height: 60px;border-radius: 5px;background: #fff;">
			<img src="/static/qmsj/img/xinzeng.png" style="width: 120px" alt="">
		</div>



		<!--月龄分布s-->
		<el-dialog class="tanchuang" title="月龄分布" :visible.sync="ylfb" width="360px">

			<div style=" background: url(/static/qmsj/img/lanshux.png) no-repeat center center;
    background-size: 2px 100%;text-align: center">
				<el-row>
					<el-col :span="12" v-for="(yl,yli) in ylfbdata1" :key="yli">
						{{yl.yue}} 个月：{{yl.shu}}人
					</el-col>
					<el-col :span="12" v-for="(yl,yli) in ylfbdata2" :key="yli">
						{{yl.yue}} 个月：{{yl.shu}}人
					</el-col>
					<el-col :span="12" v-for="(yl,yli) in ylfbdata3" :key="yli">
						{{yl.yue}} 个月：{{yl.shu}}人
					</el-col>

				</el-row>


			</div>
		</el-dialog>
		<!--月龄分布e-->


	</div>

</template>

<script>
	export default {
		data() {
			return {
				stime: '',
				etime: '',
				pickerOptions0: {
					disabledDate(time) {
						return time.getTime() < Date.now();
					},
				},
				zhou: '12',
				startTime: new Date(1989, 1, 8, 0, 0),
				endTime: new Date(1989, 1, 8, 0, 0),
				sstartTime: '',
				ylfb: false,
				token: '',
				need_classes: [],
				ylfbdata1: [],
				ylfbdata2: [],
				ylfbdata3: [],
				class_room_names: '',
				classes: '',
				teachers: '',
				infos: '',
				week: '1',
				pk_id: "",
				oldkic: '',
				olduid: '',
				s_time: '',
				e_time: '',
				os_time: '',
				oe_time: '',
				okais: '',
				ojieshu: ''
			}
		},
		created: function() {
			this.token = $.cookie('token');
			let self = this;
			$.ajax({
				url: process.env.apiUrl + 'saas/paike/index',
				dataType: 'json',
				type: 'post',
				data: {
					token: this.token,
					type: 2
				},
				success: function(data) {
					self.class_room_names = data.data.class_room_names;
					self.classes = data.data.classes;
					self.teachers = data.data.teachers;
					self.infos = data.data.infos;
					self.need_classes = data.data.need_classes;
				}
			})
		},
		watch: {
			infos: {
				handler() {
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			fanhui: function() {
				this.$router.push({
					'name': 'paikejl'
				})
			},
			old: function(okais, ojieshu) {
				this.okais = okais;
				this.ojieshu = ojieshu;

			},
			zhoucha: function() {
				let self = this;
				self.getindex()
			},
			xiugai: function(kid, uid, xh, st, et) {
				let self = this;
				self.token = $.cookie('token');
				console.log(xh)
				if (self.oldkic) {}
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/do_pk_update',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						pk_id: self.pk_id,
						kc_id: kid,
						user_id: uid,
						week: self.week,
						xiaoke:xh,
						start_time: self.stime,
						end_time: self.etime,
						before_kc_id: self.oldkic,
						before_user_id: self.olduid,
						s_time: st,
						x_time: et
					},
					success: function(data) {

						if (data.status == 1) {
							self.getindex()
						} else {
							alert(data.msg);
							self.getindex()
						}

					}
				})
			},
			pkid: function(pk_id, oldkic, olduid) {
				if (pk_id) {
					this.pk_id = pk_id
					this.oldkic = oldkic
					this.olduid = olduid
				}
			},
			getindex: function() {

				let self = this;
				self.token = $.cookie('token');

				$.ajax({
					url: process.env.apiUrl + 'saas/paike/index',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						type: 1,
						start_time: self.stime,
						end_time: self.etime,
						week: self.week,
					},
					success: function(data) {

						//                self.kjl=data.data;
						self.class_room_names = data.data.class_room_names;
						self.classes = data.data.classes;
						self.need_classes = data.data.need_classes;
						self.teachers = data.data.teachers;
						self.infos = data.data.infos;
					}
				})
			},
			ylfbfn: function() {
				this.ylfb = true;
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/yueling',
					dataType: 'json',
					type: 'post',
					data: {
						token: this.token,
						start_num:0,
						end_num:4
					},
					success: function(data) {
						// console.log(data)
						if(data.status == 1){
							self.ylfbdata1 = data.data
							self.ylfbfn1()
							self.ylfbfn2()
						}
					}
				})
			},
			ylfbfn1: function() {
				this.ylfb = true;
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/yueling',
					dataType: 'json',
					type: 'post',
					data: {
						token: this.token,
						start_num:5,
						end_num:9
					},
					success: function(data) {
						// console.log(data)
						self.ylfbdata2 = data.data
					}
				})
			},
			ylfbfn2: function() {
				this.ylfb = true;
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/yueling',
					dataType: 'json',
					type: 'post',
					data: {
						token: this.token,
						start_num:10,
						end_num:14
					},
					success: function(data) {
						self.ylfbdata3 = data.data
					}
				})
			},
			startT: function(e) {
				this.os_time = e[0]
				this.oe_time = e[1]
				console.log('______')
				console.log(e)
				console.log('______')
			},
			startTimeChange: function(e) {
				if ((typeof e) != 'object') {
					return;
				} else {
					if (e[0] >= e[1]) {
						return;
					} else {
						this.s_time = e[0];
						this.e_time = e[1];

						let stime = e[0];
						let etime = e[1];
						console.log(stime);
						console.log(etime);

						let self = this;
						if (self.stime == '' || self.etime == '') {
							alert("请先选择课程周期");
							return;
						}
						const loading = this.$loading({
							lock: true,
							text: '加载中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						$.ajax({
							url: process.env.apiUrl + 'saas/paike/do_pk',
							dataType: 'json',
							type: 'post',
							data: {
								token: this.token,
								s_time: stime,
								x_time: etime,
								start_time: self.stime,
								end_time: self.etime,
								week: self.week,
								y_s_time: self.os_time,
								y_x_time: self.oe_time,
							},
							success: function(data) {
								if (data.status == 1) {
									self.getindex();
									loading.close();
								} else {
									alert(data.msg);
									self.getindex();
									console.log(data);
									loading.close();
								}
							}
						})
					}
				}
			},
			zengjia: function() {
				var arr = [
					["", ""]
				]
				for (var i = 0; i < this.class_room_names.length; i++) {
					arr.push([])
				}
				this.infos.push(arr)
			},
			fnchang: function(d, e) {
				console.log(d)
				console.log(e)
				setTimeout(function() {
					d = ""
				}, 1000)


			},
			ffn: function() {
				alert(111)
			},
			ceshi: function() {
				console.log(new Date('2018 01 01 09:00'))
			},
			shuchuTime: function() {
				console.log(this.startTime)
				let time = new Date(this.startTime).getTime() + 60000 * 45;
				console.log(time)

				function timestampToTime(timestamp) {
					var date = new Date(timestamp)
					var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
					var m = date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes() + ':';
					var s = date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds();
					return h + m + s;
				}
				this.endTime = new Date(time)
				this.sstartTime = timestampToTime(time)

			},
			stfn2: function() {
				let self = this;
				console.log(self.stime, self.etime, self.stime > self.etime)
				if (self.stime == '' || self.stime == null || self.etime == '' || self.etime == null || self.stime > self.etime) {
					return;
				}
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/modify_pk_cycle',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						type: 2,
						y_start_time: self.okais,
						y_end_time: self.ojieshu,
						x_start_time: self.stime,
						x_end_time: self.etime
					},
					success: function(data) {
						if (data.status == 1) {
							self.getindex()
						} else {
							alert(data.msg);
							self.getindex()
						}


					}
				})
			},
			zhoufn: function() {
				let self = this;
				let zhounum = Number(self.zhou)
				let d = new Date(self.stime).getTime() + 86400000 * 7 * zhounum - 86400000;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					//                var D = date.getDate() + ' ';
					var D = date.getDate()  < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					//                return Y+M+D+h+m+s;
					return Y + M + D;
				}

				this.etime = timestampToTime(d)
				if (self.stime == '' || self.etime == '') {
					return;
				}
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/modify_pk_cycle',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						type: 2,
						y_start_time: self.okais,
						y_end_time: self.ojieshu,
						x_start_time: self.stime,
						x_end_time: self.etime
					},
					success: function(data) {

						if (data.status == 1) {
							self.getindex()
						} else {
							alert(data.msg);
							self.getindex()
						}


					}
				})
			},


		},

	}
</script>

<style scoped>
	#paike {
		min-height: 100%;
		background: #f8f8f8;
		margin: 0;
		padding: 9px;
		box-sizing: border-box;
		color: #666;
		font-size: 12px;
	}

	#paike * {
		box-sizing: border-box;
	}

	#paike ul,
	p,
	label {
		margin: 0;
		padding: 0;
	}

	#paike .xiala {
		width: 140px;
		height: 28px;
		line-height: 28px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}
</style>
<style>
	#paike .sjcj .el-input--suffix .el-input__inner {
		padding-right: 0;
		padding-left: 5px;
	}

	#paike .sjcj .el-input__prefix {
		display: none;
	}

	#paike .sjcj .el-input__icon .el-icon-time {
		display: none;
	}

	#paike .sjcj .el-input__inner {
		padding-right: 0;
		padding-left: 5px;
	}

	#paike .ivu-input-icon {
		display: none;
	}

	#paike .ivu-input-icon-normal+.ivu-input {
		padding-right: 0;
	}

	#paike .sjcj .ivu-input {
		height: 28px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/paike/paike.vue